<style lang="less">
.omHead {
  position: relative;
  top: 0;
  left: 0;
  &__sub {
    position: absolute;
    top: 0.2rem;
    right: 0.1rem;
    a {
      display: block;
      width: 2.2rem;
      border-width: 1px;
      border-style: solid;
      text-align: center;
      border-radius: 0.2rem;
      line-height: 2;
    }
  }
}
// 首条
.omFirst {
  width: 100%;
  box-sizing: border-box;
  background: url('../assets/img/bgx2.png') no-repeat;
  background-size: cover;
  background-position: 50% 0;
  margin: 0;
  padding: 0.3rem 0 0 0.3rem;
  // border-radius: 0 0 .1rem .1rem;

  &__hd:before {
    content: '';
    display: inline-block;
    width: 0.18rem;
    height: 0.3rem;
    background: url('../assets/img/xhtx2.png');
    background-size: cover;
    vertical-align: middle;
  }
  &__hdTitle {
    color: #de3031;
    font-size: 0.3rem;
    line-height: 1.5;
    display: inline-block;
    vertical-align: middle;
    font-weight: bold;
    padding: 0 0 0 0.08rem;
  }
  &__title {
    font-size: 0.32rem;
    height: 0.5rem;
    line-height: 0.5rem;
    padding: 0.1rem 0 0.1rem 0.15rem;
    color: #4c4c4c;
    font-style: normal;
  }
  &__bd {
    position: relative;
    top: 0;
    left: 0;
  }
  &__main {
    padding: 0 0 0 0.8rem;
  }
  &__avatar {
    position: absolute;
    top: 0.7rem;
    left: 0.1rem;
    width: 0.8rem;
    height: 0.8rem;
  }

  &__avatar img {
    border: 2px solid white;
    border-radius: 50%;
  }
  .omItem {
    border-left: none;
    padding: 0.2rem 0 0 0.3rem;
    &::before {
      visibility: hidden;
    }
    h3 {
      display: none;
    }
  }
}

.omList {
  padding: 0 0 1.2rem;
  background: #f5f5f5;
  width: 100%;
  &__hd {
    width: 100%;
    padding: 0.2rem 0 0.2rem 0.1rem;
    border-bottom: 1px solid #ebebeb;
    box-sizing: border-box;
  }
  &__hdTitle {
    font-size: 0.3rem;
    // line-height: .3rem;
    color: #3f8eed;
    display: inline-block;
    font-weight: normal;
    &::before {
      content: '';
      width: 0.18rem;
      height: 0.3rem;
      display: inline-block;
      background: url('../assets/img/audio_header_ioc.png') no-repeat;
      background-position: 50% 0;
      background-size: cover;
      font-weight: normal;
      vertical-align: middle;
    }
    span {
      display: inline-block;
      padding: 0 0 0 0.08rem;
      vertical-align: middle;
    }
  }
  &__bd {
    border-bottom: 1px solid #ebebeb;
  }
}
.omAdv--newsLike {
  .wzAdvPicLink {
    // border-radius: .1rem;
    background: #fff;
    padding: .15rem .1rem 0;
    // margin: .1rem 0;
    border: .1rem solid #e8e9ec;
    border-width: 0 0 .1rem;
    &__item {
      position: relative;
      top: 0;
      left: 0;
      display: block;
      padding: .05rem;
      display: block;
      // background: #000;
    }
    &__item + &__item {
      border-top: 1px solid #eee;
      padding-top: .2rem;
      .wzAdvPicLink__img {
        top: .2rem;
      }
    }

    &__img {
      width: 1.8rem;
      height: 1.8rem;
      position: absolute;
      top: .05rem;
      left: .1rem;
    }
    &__body {
      display: block;
      padding: 0 .1rem 0 2.1rem;
      min-height: 2rem;
    }
    &__title {
      display: block;
      font-size: .32rem;
    }
    &__cont {
      display: block;
      font-size: .3rem;
      color: #999;
      padding: .1rem 0;
      font-style: normal;
    }
  }
}
</style>
<template>
  <div v-if="isLoaded" class="page--list">
    <div class="omHead" v-if="firstItem">
      <div class="omFirst">
        <div class="omFirst__hd">
          <span class="omFirst__hdTitle"
            >{{ firstItem.showDate | time2text('MM月DD日') }}早盘指导：</span
          >
        </div>
        <div class="omFirst__bd">
          <h2 class="omFirst__title">{{ firstItem.title }}</h2>
          <div class="omFirst__main">
            <audio-item :item="firstItem" />
          </div>
          <div class="omFirst__avatar">
            <img src="https://staticcdn-prd.pydp888.com/g/img/tx/wz/320.jpg" />
          </div>
        </div>
      </div>
      <div class="omHead__sub"><wz-sub-btn func-type="11" /></div>
    </div>
    <div class="omAdv omAdv--newsLike">
      <k-adv page-key="/biz/wz/oneminute/list/" pos-key="m.newsLike" />
    </div>
    <div class="omAdv omAdv--slider">
      <k-adv page-key="/biz/wz/oneminute/list/" pos-key="slider" />
    </div>
    <div class="omList">
      <div class="omList__hd">
        <h2 class="omList__hdTitle">
          <span>往期精彩回顾</span>
        </h2>
      </div>
      <div class="omList__bd">
        <audio-group
          v-for="(item, index) in oldList"
          :item="item"
          :key="item.oid"
          :adv-no="makeAdvNo(index)"
          :class="`lsItem--${index}`"
        />
      </div>
    </div>
  </div>
  <div v-else class="page--loading">
    <p>数据加载中…</p>
  </div>
</template>

<script>
import { WZ } from '../utils/wz.v2'
import AudioGroup from './comp/audio-group'
import AudioItem from './comp/audio-item'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    AudioGroup,
    AudioItem
  },
  computed: {
    ...mapGetters('oneminute', ['isLoaded', 'oldList', 'firstItem'])
  },
  methods: {
    ...mapActions('oneminute', ['load']),
    makeAdvNo(i) {
      const p = 4
      const mod = i % p
      return i && !mod ? Math.ceil(i / p) : 0
    }
  },
  async created() {
    await this.load()
    const { firstItem } = this
    if (!firstItem) {
      return
    }
    let shareTitle = firstItem && firstItem.title ? firstItem.title : '早盘指导'
    shareTitle = shareTitle.replace(/^\s*早盘指导[:：]?/, '')
    shareTitle = '早盘|' + shareTitle
    let date = firstItem.showDate || firstItem.pubTime || ''
    date = date.slice(5, 10)
    if (date) {
      shareTitle = date.replace(/\-/, '.') + '' + shareTitle
    }
    document.title = shareTitle
    // console.log(firstItem)
    WZ.wxInit({
      shareUrl: location.href,
      shareImgUrl: 'https://staticcdn-prd.pydp888.com/g/img/logo/512.jpg',
      shareTitle,
      shareDescription:
        '每天更新，王者对当日大盘走势预判，为股民实时解读股市行情，挖掘交易良机，传授实战技巧！'
    })

    const kStat = window.kStat
    if (kStat && kStat.makeShare) {
      kStat.makeShare({
        url: location.href,
        image: 'https://staticcdn-prd.pydp888.com/g/img/logo/512.jpg',
        title: shareTitle,
        description:
          '每天更新，王者对当日大盘走势预判，为股民实时解读股市行情，挖掘交易良机，传授实战技巧！'
      })
    }
  }
}
</script>
